import React from "react";
import { useProductCardContext } from "web/react/components/product-card/react";
import { Price } from "web/react/emo/product-price";

export function ProductPrice({ size }: { size: "sm" | "md" | "lg" }): JSX.Element {
    const {
        full_price_with_currency_symbol: fullPriceWithCurrencySymbol,
        sale_price_with_currency_symbol: salePriceWithCurrencySymbol,
        sale_discount: saleDiscount,
        in_stock: inStock,
    } = useProductCardContext();

    if (!saleDiscount) {
        return (
            <Price
                size={size}
                fullPrice={fullPriceWithCurrencySymbol as string}
                inStock={inStock}
                dataTestId="not-on-sale"
            />
        );
    }

    return (
        <Price
            size={size}
            fullPrice={fullPriceWithCurrencySymbol as string}
            salePrice={salePriceWithCurrencySymbol as string}
            inStock={inStock}
            dataTestId="is-on-sale"
        />
    );
}
